const data = [
  "Can you provide insights on the performance of my YouTube channel?",
  "What strategies do you recommend to improve my YouTube channel's performance?",
  "How can I optimize my YouTube channel to reach a wider audience?",
  "What are some effective ways to engage my YouTube subscribers?",
  "Are there any specific areas of improvement you suggest for my YouTube channel?",
];

export default data;
